import { Divider, Stack, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import { ActiveOrganizationLabel } from "src/components/ActiveOrganizationLabel";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

type ActiveOrganizationContextHeaderProps = {
    title: ReactNode;
    context?: ReactNode;
    sx?: SxProps<Theme>;
    titleSx?: SxProps<Theme>;
    contextRowSx?: SxProps<Theme>;
    contextSx?: SxProps<Theme>;
    labelSx?: SxProps<Theme>;
};

export const ActiveOrganizationContextHeader = (props: ActiveOrganizationContextHeaderProps) => {
    const { title, context, titleSx, labelSx, contextRowSx, contextSx, sx } = props;

    const { selectedCompany } = useFoodpilotContext();
    const contextNode = context ?? (selectedCompany?.name ? <ActiveOrganizationLabel sx={labelSx} /> : null);

    return (
        <Stack direction="row" alignItems="center" gap={2} minWidth={0} sx={sx}>
            <Stack direction="row" alignItems="center" minWidth={0} sx={titleSx}>
                {title}
            </Stack>

            {contextNode && (
                <Stack direction="row" alignItems="center" gap={2} minWidth={0} sx={contextRowSx}>
                    <Divider
                        orientation="vertical"
                        flexItem
                        sx={{
                            height: "50px",
                            borderColor: (theme) => theme.custom.grey[500],
                            flexShrink: 0,
                            mx: 0,
                        }}
                    />
                    <Stack direction="row" alignItems="center" minWidth={0} sx={contextSx}>
                        {contextNode}
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};
